import { render, staticRenderFns } from "./Works.TheCoachingManual.vue?vue&type=template&id=5996cbf4&scoped=true&"
import script from "./Works.TheCoachingManual.vue?vue&type=script&lang=js&"
export * from "./Works.TheCoachingManual.vue?vue&type=script&lang=js&"
import style0 from "./Works.TheCoachingManual.vue?vue&type=style&index=0&id=5996cbf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996cbf4",
  null
  
)

export default component.exports